import { BoltApiClient } from "@bolt/core";
import { BoltDocumentTemplate } from "../../types/types";

export class BoltDocumentTemplateApiClient {
  constructor(private readonly boltApiClient: BoltApiClient) {}

  async createTemplate(
    id: string,
    templateName: string
  ): Promise<BoltDocumentTemplate> {
    return this.boltApiClient.post<BoltDocumentTemplate>(
      `/document-templates/${id}`,
      {
        templateName,
      }
    );
  }

  async updateTemplate(
    templateId: string,
    templateName: string
  ): Promise<BoltDocumentTemplate> {
    return this.boltApiClient.put<BoltDocumentTemplate>(
      `/document-templates/${templateId}`,
      {
        templateName,
      }
    );
  }

  async deleteTemplate(templateId: string): Promise<void> {
    return this.boltApiClient.delete(`/document-templates/${templateId}`);
  }

  async getTemplate(templateId: string): Promise<BoltDocumentTemplate> {
    return this.boltApiClient.get<BoltDocumentTemplate>(
      `/document-templates/${templateId}`
    );
  }

  async getDocumentTemplateFile(templateId: string): Promise<string> {
    return this.boltApiClient.get<string>(
      `/document-templates/${templateId}/file`
    );
  }

  async populateDocumentTemplate(
    templateId: string,
    modelName: string,
    modelId: string
  ): Promise<Blob> {
    return this.boltApiClient.download<any>(
      `/document-templates/${templateId}/populate/pdf`,
      {
        modelName,
        modelId,
      }
    );
  }
}

export const createBoltDocumentTemplateApiClient = (
  boltApiClient: BoltApiClient
) => {
  return new BoltDocumentTemplateApiClient(boltApiClient);
};
